import {
  ADD_LOCATION_BY_STEP,
  CHANGE_TAB,
  SUBMIT_ADD_LOCATION,
} from './actionTypes';

export const actionAddLocationByStep = (payload) => ({
  payload,
  type: ADD_LOCATION_BY_STEP,
});

export const actionSubmitAddLocation = (payload) => ({
  payload,
  type: SUBMIT_ADD_LOCATION,
});

export const actionChangeTab = (payload) => ({
  payload,
  type: CHANGE_TAB,
});
